import axios from '@/libs/api.request'
import urlObj from '@/config/env.js'
// 列表/查询
export function getRoleList(params) {
  return axios.request({
    url: urlObj.crm + 'uims-oauth/role',
    method: 'get',
    params
  })
}

// 查询当前租户套餐资源
export function getTree(params) {
  return axios.request({
    url:
      urlObj.crm + 'uims-oauth/setmeal/tenant/resource/tree',
    method: 'get',
    params
  })
}

// 查询角色菜单资源列表
export function getResource(params) {
  return axios.request({
    url: urlObj.crm + 'uims-oauth/assets/role/resource',
    method: 'get',
    params
  })
}
// 修改角色资源
export function saveResource(data) {
  return axios.request({
    url: urlObj.crm + 'uims-oauth/role/setmeal/resource',
    method: 'post',
    data
  })
}
// 新增
export function saveData(params) {
  return axios.request({
    url: urlObj.crm + 'uims-oauth/role',
    method: 'post',
    params
  })
}

// 尚亚丹之前写的
// 修改角色名称
export function editData(params) {
  return axios.request({
    url: urlObj.crm + 'uims-oauth/role',
    method: 'put',
    params
  })
}

// 删除
export function delData(params) {
  return axios.request({
    url: urlObj.crm + 'uims-oauth/role',
    method: 'delete',
    params
  })
}

// 极联树形图列表
export function getTreeData() {
  return axios.request({
    url: `${urlObj.crm}uims-resource/menu/findAllMenu/1450035694644305928`,
    method: 'get'
  })
}

// 查询当前用户的角色资源  --> ?
export function getUserRole(params) {
  return axios.request({
    url: `${urlObj.crm}uims-oauth/authority/role/resources`,
    method: 'get',
    params
  })
}

// 新增用户角色资源
export function setNewUserRole(params) {
  return axios.request({
    url: `${urlObj.crm}uims-resource/resource/role`,
    method: 'post',
    params
  })
}
// 修改已有用户角色资源
export function setOldUserRole(params) {
  return axios.request({
    url: `${urlObj.crm}uims-resource/resource/role/refresh`,
    method: 'post',
    params
  })
}
